import SingleSelectPage from "@components/SingleSelectPage"

const OPTIONS = ["yes", "no"] as const

export default function CalorieCountingExperience() {
  return (
    <SingleSelectPage
      translationKey="calorieCountingExperience"
      options={OPTIONS}
    />
  )
}
